import React from 'react';
import PropTypes from 'prop-types';
import {List} from 'antd';

import {ColorfulList} from '@/component';
import UserExtLabel from '@/page/component/UserExtLabel';
import styles from '@/page/admin/selector/DepartUserTagSelector/MainPanel.module.less';

export default function AppAllowUserTabPane({allowUsers, onAddSelected}) {
    // console.log('allowUsers', allowUsers);

    function onItemClick(item) {
        const { allowId: id, allowName: name, buId } = item;
        onAddSelected && onAddSelected('users', { id, name, buId });
    }

    function renderItem(item) {
        return (
            <List.Item>
                <List.Item.Meta
                    title={item.allowName}
                    description={<UserExtLabel userId={item.allowId} />}
                />
            </List.Item>
        );
    }

    return (
        <div className={styles.tabContent1}>
            <ColorfulList
                onItemClick={onItemClick}
                dataSource={allowUsers}
                renderItem={renderItem}
            />
        </div>
    );
}

AppAllowUserTabPane.propTypes = {
    allowUsers: PropTypes.array,
    onAddSelected: PropTypes.func,
};
